export default "__VITE_ASSET__CluyVpvk__"